// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardBody_cardBody__yn7lv {
  width: 70vh;
  height: 40%;
  margin: auto;
  margin-top: 5%;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  border-radius: 15px;
  padding: 5%;
  background: #fff;
  box-shadow: 0px 6px 6px -3px rgb(0 0 0 / 20%), 0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%);
}

.CardBody_heading__KR-vG {
  text-align: center;
  font-size: 2rem;
  color: #102364;
  margin: 0;
}

.CardBody_score__e8sr6 {
  color: #0D95BB;
  font-size: 4rem;
  margin: 0
}

.CardBody_firstCol__wxX7m {
  color: #102364;
  text-align: center;
}


.CardBody_mb2__0\\+ZAe {
  margin-top: 1rem;
}

.CardBody_mb1__9Yu\\+j {
  margin: 0;
  margin-bottom: 0.5rem;
}


.CardBody_secondCol__B6mdm {
  width: auto;
  margin: auto;
  text-align: center;
}

.CardBody_case__xGIch {
  list-style: none;
  color: #0D95BB;
  margin-bottom: 0.25rem;
}

.CardBody_skillschart__Qown- {
  margin-top: 4%;
}

.CardBody_solved__tOK9s {
  color: #0D95BB
}

@media (max-width: 800px) {
  .CardBody_cardBody__yn7lv {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1.2rem;
  }

  .CardBody_secondCol__B6mdm {
    width: auto;
    margin: auto;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .CardBody_cardBody__yn7lv {
    padding: 0.75rem !important;
    width: 80vw;

    /* over */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/CardBody.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,oHAAoH;AACtH;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,WAAW;;IAEX,SAAS;EACX;AACF","sourcesContent":[".cardBody {\n  width: 70vh;\n  height: 40%;\n  margin: auto;\n  margin-top: 5%;\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n  border-radius: 15px;\n  padding: 5%;\n  background: #fff;\n  box-shadow: 0px 6px 6px -3px rgb(0 0 0 / 20%), 0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%);\n}\n\n.heading {\n  text-align: center;\n  font-size: 2rem;\n  color: #102364;\n  margin: 0;\n}\n\n.score {\n  color: #0D95BB;\n  font-size: 4rem;\n  margin: 0\n}\n\n.firstCol {\n  color: #102364;\n  text-align: center;\n}\n\n\n.mb2 {\n  margin-top: 1rem;\n}\n\n.mb1 {\n  margin: 0;\n  margin-bottom: 0.5rem;\n}\n\n\n.secondCol {\n  width: auto;\n  margin: auto;\n  text-align: center;\n}\n\n.case {\n  list-style: none;\n  color: #0D95BB;\n  margin-bottom: 0.25rem;\n}\n\n.skillschart {\n  margin-top: 4%;\n}\n\n.solved {\n  color: #0D95BB\n}\n\n@media (max-width: 800px) {\n  .cardBody {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 1.2rem;\n  }\n\n  .secondCol {\n    width: auto;\n    margin: auto;\n    text-align: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .cardBody {\n    padding: 0.75rem !important;\n    width: 80vw;\n\n    /* over */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `CardBody_cardBody__yn7lv`,
	"heading": `CardBody_heading__KR-vG`,
	"score": `CardBody_score__e8sr6`,
	"firstCol": `CardBody_firstCol__wxX7m`,
	"mb2": `CardBody_mb2__0+ZAe`,
	"mb1": `CardBody_mb1__9Yu+j`,
	"secondCol": `CardBody_secondCol__B6mdm`,
	"case": `CardBody_case__xGIch`,
	"skillschart": `CardBody_skillschart__Qown-`,
	"solved": `CardBody_solved__tOK9s`
};
export default ___CSS_LOADER_EXPORT___;
